import { useEffect } from 'react'
import { useNavigate, Link } from 'react-router-dom'
import { LoginForm } from '@/components/login-form'
import { getSessionCookie } from '@/lib/cookies'

const HoomiLogo = '/assets/hoomi-logo.png'

export default function Auth() {
  const navigate = useNavigate()

  useEffect(() => {
    if (getSessionCookie()) {
      navigate('/authorized', { replace: true })
    }
  }, [navigate])

  return (
    <div className="bg-black flex min-h-svh flex-col items-center justify-center gap-6 p-6 md:p-10 text-white relative">
      {/* Purple gradient background */}
      <div className="absolute inset-0 bg-gradient-to-br from-black via-purple-950/30 to-black z-0"></div>

      {/* Purple accent elements */}
      <div className="absolute top-0 right-0 w-1/3 h-1/3 bg-purple-500/5 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 left-0 w-1/4 h-1/4 bg-purple-500/10 rounded-full blur-3xl"></div>

      {/* Header with logo */}
      <div className="absolute top-0 left-0 w-full p-4 flex items-center">
        <Link to="/" className="flex items-center gap-2">
          <img src={HoomiLogo} alt="Hoomi Social" width={24} height={24} />
          <span className="font-semibold text-purple-300">Hoomi Social</span>
        </Link>
      </div>

      {/* Login form container with glass effect */}
      <div className="w-full max-w-sm z-10 bg-black/30 backdrop-blur-lg rounded-xl border border-purple-500/20 shadow-xl shadow-purple-500/10 p-6">
        <LoginForm />
      </div>
    </div>
  )
}